module.exports = __webpack_public_path__ + "static/month-main-event-theme-8639738a3d05f4034f52308e62d46bc3.png";